import {
  Component,
  OnInit
} from '@angular/core';
import {
  ModalController,
  NavParams,
  Platform
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { AuthorizationService } from '@auth/services/authorization.service';
import { User } from '@shared/Interface/user';
import { CommonUtilitiesService } from '@shared/service/common-utilities.service';

@Component({
  selector: 'app-modeldropdown',
  templateUrl: './modeldropdown.component.html',
  styleUrls: ['./modeldropdown.component.scss'],
})

export class ModeldropdownComponent implements OnInit {
  displayProperty: string;
  title: string;
  selectedItem: any;
  currentUser: User;
  currentUserSubscription: Subscription;

  searchTerm = '';
  searchText = '';

  results: Observable<any[]>;
  information: Observable<any[]>;

  constructor(private navParams: NavParams,
    private platform: Platform,
    private modelViewCnt: ModalController,
    private authenticationService: AuthorizationService,
    private commonUtils: CommonUtilitiesService) {
  }

  ngOnInit() {
    this.commonUtils.presentLoding('loading...');
    this.initializeItems();
    this.title = this.navParams.get('title');

    if (!this.title) this.title = 'Select...';
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user["data"][0][0];
    })

    this.platform.ready().then(() => {
      document.addEventListener("backbutton", () => {
        // code that is executed when the user pressed the back button
        this.dismiss();
      });
    });
  }

  initializeItems() {
    // console.log("list:  " + JSON.stringify(this.navParams.get('list')));
    this.results = this.navParams.get('list');
    this.information = this.results;
    this.displayProperty = this.navParams.get('key');
    // this.commonUtils.dismiss();
    setTimeout(() => {
      this.commonUtils.dismiss();
    }, 1500);
  }

  filterMe() {
    this.searchText = '';
    if (this.searchTerm != null) {
      this.searchText = this.searchTerm.toLowerCase();
    } else {
      this.searchText = '';
    }
    this.results = this.information
      .pipe(
      map(results => results.filter(r => r[this.displayProperty].toString().toLowerCase().indexOf(this.searchText) > -1))
      );
  }

  dismiss() {
    this.modelViewCnt.dismiss(this.selectedItem);
  }

  closeModal() {
    this.modelViewCnt.dismiss();
  }

  select(i) {
    this.selectedItem = i;
  }
}
